// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__b638R","shadow":"style_shadow__1dodV","intersectionObserver":"style_intersectionObserver__zY_kA","backButton":"style_backButton__JWr6G"};